export interface BlogPost {
  slug: string;
  title: string;
  excerpt: string;
  content: string;
  date: string;
  author: string;
  category: string;
  readTime: string;
  image: string;
}

export const blogPosts: BlogPost[] = [
  {
    slug: 'nanocoating-vs-traditional',
    title: 'Nanocoating vs. Traditional Sealants: What You Need to Know',
    excerpt: 'A comprehensive comparison between modern nanocoatings and traditional surface protection methods.',
    content: `
      <p class="mb-4">When it comes to protecting your valuable surfaces, the choice between traditional sealants and modern nanocoatings is crucial. While traditional methods have served us well for decades, nanotechnology brings a paradigm shift in how we approach surface protection.</p>
      <h2 class="text-2xl font-bold text-[#1D1D1F] mt-8 mb-4">The Molecular Difference</h2>
      <p class="mb-4">Traditional sealants sit on top of the surface, creating a layer that can wear off over time. Nanocoatings, on the other hand, bond at a molecular level, becoming part of the surface itself. This results in superior durability and longevity.</p>
      <h2 class="text-2xl font-bold text-[#1D1D1F] mt-8 mb-4">Key Benefits</h2>
      <ul class="list-disc pl-5 space-y-2 mb-6">
        <li><strong>Hydrophobicity:</strong> Nanocoatings repel water and liquids effectively.</li>
        <li><strong>Breathability:</strong> Unlike some sealants, nanocoatings allow the surface to breathe.</li>
        <li><strong>UV Protection:</strong> Enhanced resistance against sun damage.</li>
      </ul>
      <p class="mb-4">Investing in nanocoating technology is not just about protection; it's about preserving the aesthetic integrity of your spaces for years to come.</p>
    `,
    date: 'November 12, 2023',
    author: 'James Wilson',
    category: 'Education',
    readTime: '4 min read',
    // Macro water droplet on a surface — visualises the hydrophobic
    // behaviour the article centres on.
    image: 'https://images.unsplash.com/photo-1559827260-dc66d52bef19?auto=format&fit=crop&w=1200&q=80'
  },
  {
    slug: 'sustainable-architecture-trends',
    title: 'Sustainable Architecture: The Role of Protective Coatings',
    excerpt: 'Exploring how long-lasting surface protection contributes to sustainable building practices.',
    content: `
      <p class="mb-4">Sustainability in architecture goes beyond just using eco-friendly materials. It encompasses the entire lifecycle of a building, including maintenance and longevity. This is where protective coatings play a pivotal role.</p>
      <h2 class="text-2xl font-bold text-[#1D1D1F] mt-8 mb-4">Extending Material Lifespan</h2>
      <p class="mb-4">By protecting surfaces from weathering, staining, and corrosion, we significantly extend the life of building materials. This reduces the need for replacements and repairs, thereby lowering the carbon footprint associated with manufacturing and transport.</p>
      <h2 class="text-2xl font-bold text-[#1D1D1F] mt-8 mb-4">Reducing Chemical Usage</h2>
      <p class="mb-4">Surfaces treated with Magia's nanocoatings are easier to clean, often requiring just water. This eliminates the need for harsh cleaning chemicals that can be harmful to the environment.</p>
      <p class="mb-4">As we move towards a greener future, integrating advanced protection solutions is a step towards more responsible and durable architecture.</p>
    `,
    date: 'December 05, 2023',
    author: 'Elena Rodriguez',
    category: 'Sustainability',
    readTime: '6 min read',
    // Modern building integrated with greenery — visual for sustain-
    // able architecture / green-building practices.
    image: 'https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?auto=format&fit=crop&w=1200&q=80'
  },
  {
    slug: 'maintaining-luxury-interiors',
    title: 'The Art of Maintaining Luxury Interiors',
    excerpt: 'Expert tips on keeping your high-end finishes looking pristine with minimal effort.',
    content: `
      <p class="mb-4">Luxury interiors demand a level of care that matches their elegance. However, maintaining that showroom shine doesn't have to be a chore. With the right approach, you can keep your spaces looking immaculate.</p>
      <h2 class="text-2xl font-bold text-[#1D1D1F] mt-8 mb-4">Prevention is Key</h2>
      <p class="mb-4">The best way to handle stains and wear is to prevent them. Protective coatings act as an invisible shield, stopping liquids and dirt from penetrating porous surfaces like marble, fabric, and wood.</p>
      <h2 class="text-2xl font-bold text-[#1D1D1F] mt-8 mb-4">Routine Care</h2>
      <p class="mb-4">For treated surfaces, a simple wipe-down with a microfiber cloth is often all that's needed. Avoid abrasive scrubbers that can dull the finish. Regular, gentle cleaning prevents buildup and maintains the surface's natural luster.</p>
      <p class="mb-4">Magia's solutions are designed to make this maintenance effortless, giving you more time to enjoy your beautiful home.</p>
    `,
    date: 'January 18, 2024',
    author: 'Michael Chang',
    category: 'Lifestyle',
    readTime: '3 min read',
    // High-end living room — fits the "luxury interior maintenance"
    // angle of the post.
    image: 'https://images.unsplash.com/photo-1586023492125-27b2c045efd7?auto=format&fit=crop&w=1200&q=80'
  }
];